// extracted by mini-css-extract-plugin
export default {"block":"ForgotPassword_block__VNszr","link":"ForgotPassword_link__br9Ml"};